import {
	Delete as DeleteIcon,
	Edit as EditIcon,
	FileCopy as FileCopyIcon,
	History as HistoryIcon,
	Image as ImageIcon,
	InsertChart as InsertChartIcon,
	KeyboardTab as KeyboardTabIcon,
	Room as MapIcon,
	Visibility as VisibilityIcon,
	PictureAsPdf as PdfIcon,
	AutoFixHigh,
	QuestionMark,
	OpenInNew as OpenInNewIcon,
} from '@mui/icons-material'
import ReplyIcon from '@mui/icons-material/Reply'
import ShortcutIcon from '@mui/icons-material/Shortcut'
import { IconButton, Tooltip } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'
import { LoadingButton } from '@mui/lab'
import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { cloneDeep } from 'lodash'
import {
	DataGridPremium,
	GridActionsCellItem,
	GridFooterContainer,
	GridPagination,
	GridToolbarContainer,
	GridToolbarDensitySelector,
	GridToolbarFilterButton,
	gridFilteredSortedRowIdsSelector,
	gridSortedRowIdsSelector,
	gridPaginatedVisibleSortedGridRowEntriesSelector,
	useGridApiRef,
} from '@mui/x-data-grid-premium'
// import { gridVisibleSortedRowIdsSelector } from '@mui/x-data-grid-pro'
import { debounce, isEmpty } from 'lodash'
import moment from 'moment'
import {
	useCallback,
	useContext,
	useEffect,
	useLayoutEffect,
	useMemo,
	useRef,
	useState,
} from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import {
	checkAdminRole,
	getAggregationModel,
	getRowGroupingModel,
	getSortModel,
	isNumber,
	getSizedSessionStorage,
	saveSizedSessionStorage,
} from 'utils/functions/helpers'
import { useFirstRender } from 'utils/hooks/useFirstRender'
import {
	ACTIVITY_DEVICE_LIST,
	ACTIVITY_RECEIVE_TIME_KEY,
	HELP_LINK_CONDITION_FILTERS,
	TabList,
	VIEW,
} from '../../../constants'
import DoformsMessage from '../../../custom-components/DoformsMessage'
import { IconThemeContext } from '../../../custom-components/context/IconThemesContext'
import { ACTIVITY_ACTIONS } from '../../../reducers/activityReducer'
import { DEVICES_ACTIONS } from '../../../reducers/devicesReducer'
import { ENV_ACTIONS } from '../../../reducers/environmentReducer'
import { FORM_ACTIONS } from '../../../reducers/formsReducer'
import { LOOKUPS_ACTIONS } from '../../../reducers/lookupsReducer'
import { VIEWS_ACTIONS } from '../../../reducers/viewsReducer'
import { parsedDataGridColumns, parsedDataGridRecords } from '../dataHelpers'
import { getFormSelectedFromActivityKey } from '../dataServices'
import DoformsCreateSubmission from '../submissions/DoformsCreateSubmission'
import DoformsConditionFilters from './DoformsConditionFilters'
import DoformsDataChart from './DoformsDataChart'
import DoformsDataColumns from './DoformsDataColumns'
import DoformsDataGridRefresh from './DoformsDataGridRefresh'
import DoformsDataImportView from './DoformsDataImportView'
import DoformsDataSaveView from './DoformsDataSaveView'
import DoformsDataViewDelete from './DoformsDataViewDelete'
import DoformsChartGrid from './DoformsGridChart'
import DoformsMultiSelectDelete from './DoformsMultiSelectDelete'
import DoformsRecordsActions from './DoformsRecordsActions'
import ExportButton from './ExportButton'
import UpdateAlert from './UpdateAlert'
import ToastAlert from 'components/core/Layouts/ToastAlert'
import {
	CustomPagination,
	PAGE_SIZE_LIST,
	DEFAULT_PAGE_SIZE,
} from './DatagridCustomComponent/CustomPagination'

const useStyles = makeStyles(() => ({
	root: {
		'& .MuiButton-root': {
			textTransform: 'none',
		},
		'& .MuiList': {
			backgroundColor: 'ghostwhite',
		},
		'& .MuiDataGrid-footerContainer': {
			width: '100%',
			display: 'inline-flex',
			justifyContent: 'space-between',
			'& .MuiTablePagination-selectLabel': {
				marginTop: '1em',
			},
			'& .MuiTablePagination-displayedRows': {
				marginTop: '1em',
			},
		},
		'& .MuiDataGrid-columnHeader': {
			'& .MuiDataGrid-columnHeaderTitle': {
				lineHeight: '20px',
				fontSize: '14px',
			},
		},
		'& .MuiDataGrid-main': {
			minHeight: '200px',
		},
		'&.grid-loaded .MuiDataGrid-main': {
			minHeight: '500px',
			overflowY: 'hidden',
		},
	},
	headingContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
	headingLabel: {
		display: 'flex',
		paddingLeft: '10px',
		minHeight: '32px',
	},
	headingAction: {
		display: 'flex',
		alignItems: 'center',
	},
	gridContainer: {
		display: 'flex',
		flexDirection: 'column',
		paddingTop: '10px',
		height: '100%',
	},
	gridFooterActions: {
		display: 'flex',
		alignItems: 'center',
		height: '100%',
	},
	subheader: {
		display: 'flex',
		alignItems: 'center',
		// justifyContent: 'space-between',
		'& .MuiButton-root': {
			textTransform: 'none',
		},
	},
	dataGridToolbar: {
		minHeight: 20,
		paddingLeft: '0px',
		paddingBottom: '8px',
	},
	icon: (props) => ({
		color: props.color,
		'&:hover': {
			color: props.active.color,
			backgroundColor: 'transparent',
		},
	}),
	loadAllIcon: (props) => ({
		color: props.color,
		'&:hover': {
			color: props.active.color,
			backgroundColor: 'transparent',
		},
	}),
	cancelLoadingIcon: (props) => ({
		color: props.color,
		'&:hover': {
			color: props.active.color,
			backgroundColor: 'transparent',
		},
	}),
	spanLink: {
		paddingTop: '10px',
	},
	updateAlert: {
		backgroundColor: '#1a6891',
		color: '#fff',
		textAlign: 'center',
		cursor: 'pointer',
	},
	titleFooter: {
		display: 'flex',
		marginLeft: '10px',
	},
	loadAllFooter: {
		display: 'flex',
		marginLeft: '10px',
	},
	loadAllToolbar: {
		paddingBottom: '10px',
	},
}))

const DoformsDataGrid = (props) => {
	const [t] = useTranslation('common')
	const {
		clientFilters,
		setError,
		isLoading,
		formSelected,
		setActionView,
		isRefresh,
		environment,
		query,
		viewData,
		title,
		titleFooter,
		queryView,
		columns,
		records,
		recordsLoading,
		allRecordsLoading,
		deviceSelected,
		tab,
		rowsPerPage,
		onHandledResizeColumn,
		onHandledLoadAllRecords,
		onHandledCancelLoadingRecords,
		onHandlePresetReloadAll,
		onHandleLoadRecordsByPagination,
		onHandleReLoadFirstPage,
		onHandleOpenFullScreenViewsTab,
		onHandleOpenFullScreenFormsTab,
		onHandleOpenFullScreenLookupsTab,
		onHandleOpenFullScreenDevicesTab,
		setLoading,
	} = props

	const { iconTheme } = useContext(IconThemeContext)
	const classes = useStyles(iconTheme)
	const isFirstRender = useFirstRender()
	const [showGrid, setShowGrid] = useState(false)
	const apiRef = useGridApiRef()
	const gridRef = useRef(null)

	const [selectionModel, setSelectionModel] = useState([])

	const [action, setAction] = useState(null)
	const [actionRecord, setActionRecord] = useState(null)
	const [open, setOpen] = useState(false)
	const dispatch = useDispatch()
	const [paramSave, setParamSave] = useState(null)
	const [gridRowIDs, setGridRowIDs] = useState([])
	const [gridRows, setGridRows] = useState([])
	const [updateGridRowIDSs, setUpdateGridRowIDSs] = useState(false)
	const [openGalleryView, setOpenGalleryView] = useState(false)
	const [viewTitle, setViewTitle] = useState('')
	const [hoverTrigger, setHoverTrigger] = useState('draft')
	const [triggerShowChart, setTriggerShowChart] = useState(false)
	const [info, setInfo] = useState(null)
	const [isFormDeleted, setIsFormDeleted] = useState(false)
	const [aggregationModel, setAggregationModel] = useState({})
	const [rowGroupingModel, setRowGroupingModel] = useState([])
	const [alertInfo, setAlertInfo] = useState({
		open: false,
		text: '',
		type: 'success',
	})
	const [sortModel, setSortModel] = useState([])
	const [density, setDensity] = useState('compact')

	const [paginationModel, setPaginationModel] = useState({
		page: 0,
		pageSize: DEFAULT_PAGE_SIZE,
	})

	const isMounted = useRef(true)
	const formMapRef = useRef(null)

	const reorderingRef = useRef({
		isDragging: false,
		oldIndex: null,
		targetIndex: null,
	})

	const clientFilterKey = useMemo(() => {
		switch (tab) {
			case 'views':
				return viewData?.key ?? ''
			case 'devices':
				return deviceSelected?.key ?? ''
			case 'activity':
				return 'activity'
			default:
				return `${formSelected?.key ?? ''}`
		}
	}, [viewData?.key, deviceSelected?.name, formSelected?.key, tab])

	const clientFiltersMemo = useMemo(() => {
		if (!clientFilters?.[clientFilterKey]) return undefined
		return clientFilters[clientFilterKey]
	}, [clientFilters, clientFilterKey])

	const clientFiltersMemoWithoutColumnField = useMemo(() => {
		return clientFiltersMemo?.items
			? clientFiltersMemo?.items?.filter((item) => !item.columnField)
			: clientFiltersMemo?.filter((item) => !item.columnField)
	}, [clientFiltersMemo])

	const canChangeFilter = useMemo(() => {
		if (isEmpty(clientFiltersMemoWithoutColumnField)) {
			return true
		}
		return checkAdminRole(environment?.userCurrent) || tab !== TabList.Views.toLowerCase()
	}, [environment?.userCurrent, tab, clientFiltersMemoWithoutColumnField])

	const showInfoMessage = () =>
		info && (
			<DoformsMessage message={info} severity={'info'} onMessageClosed={() => setInfo(null)} />
		)

	useEffect(() => {
		isMounted.current = true
		return () => (isMounted.current = false)
	}, [])

	useLayoutEffect(() => {
		setActionView?.(action)
	}, [action])

	useLayoutEffect(() => {
		// first load
		if (recordsLoading === undefined) {
			setAction(null)
			setActionRecord(null)
			setOpen(false)
			setOpenGalleryView(false)
		}
	}, [recordsLoading])

	const getQueryConditions = (queries) => {
		if (isEmpty(queries)) return []
		if (!queries[0].filter) return []
		let conditions = queries[0].filter.conditions
		if (!conditions[1]) {
			conditions[1] = { preset: 'ALL', target: '@UserStatus', type: 'EQ' }
		} else {
			if (conditions[1].target === '@InProgress') {
				conditions[1].target = '@UserStatus'
			}
			if (conditions[1].type === 'IN') {
				conditions[1].type = 'EQ'
			}
		}

		if (conditions[1].target === ACTIVITY_RECEIVE_TIME_KEY) {
			return [...conditions].reverse()
		}
		return conditions
	}

	useEffect(() => {
		if (isEmpty(viewData)) {
			setShowGrid(false)
			return
		}
		setShowGrid(true)
		const sortModel = getSortModel(viewData.columns, viewData?.sorts)
		setSortModel(isEmpty(sortModel) ? [] : sortModel)
	}, [viewData])

	useEffect(() => {
		return () => window.sessionStorage.removeItem('grid-rows-tmp')
	}, [])

	useEffect(() => {
		if (!records) return
		const gridRowsTmpSession = getSizedSessionStorage('grid-rows-tmp')
		const gridRowsTmpSessionData = isEmpty(gridRowsTmpSession) ? [] : gridRowsTmpSession
		if (gridRowsTmpSessionData.length > 0 && isFirstRender) {
			setGridRows(gridRowsTmpSessionData)
			return
		}
		let gridRowsTmp = parsedDataGridRecords(records, columns, environment, [])
		saveSizedSessionStorage('grid-rows-tmp', gridRowsTmp)

		const keyInGridRowsTmp = gridRowsTmp?.[0] ? Object.keys(gridRowsTmp[0]) : []
		window.sessionStorage.setItem('full_columns_keys', JSON.stringify(keyInGridRowsTmp))
		setGridRows(gridRowsTmp)

		let gridRowIDsTmp = []
		for (var i = 0; i < gridRowsTmp.length; i++) {
			gridRowIDsTmp.push(gridRowsTmp[i].id)
		}
		setGridRowIDs(gridRowIDsTmp)
		setSelectionModel([])
		if (environment && environment.chartDS) {
			dispatch({
				type: ENV_ACTIONS.CHART_DS,
				payload: null,
			})
		}
	}, [records])

	useEffect(() => {
		if (!gridRowIDs || !gridRowIDs.length || !gridRows || !gridRows.length) return
		for (var i = 0; i < gridRows.length; i++) {
			if (gridRowIDs[i] != undefined) {
				gridRows[i]['@displayId'] = gridRowIDs[i]
			}
		}

		setGridRows(gridRows)
	}, [gridRowIDs])

	useEffect(() => {
		if (!updateGridRowIDSs || !apiRef) return

		let gridRowIDsNew = getGridRowIDs(apiRef)
		if (JSON.stringify(gridRowIDs) != JSON.stringify(gridRowIDsNew)) {
			setGridRowIDs(gridRowIDsNew)
		}
		setUpdateGridRowIDSs(false)
	}, [updateGridRowIDSs])

	const hasManageRights = useMemo(() => {
		if (!environment) return []

		return checkAdminRole(environment?.userCurrent) || false
	}, [columns])

	const gridColumns = useMemo(() => {
		if (!columns) return []
		if (!columns.length) return []
		return parsedDataGridColumns(environment, columns)
	}, [columns])

	const cloneColumns = useMemo(() => {
		if (!columns) return []
		if (!columns.length) return []
		return [...columns]
	}, [columns])

	const hasAggregationModel = useMemo(() => !isEmpty(aggregationModel), [aggregationModel])

	useEffect(() => {
		// Set filter model base on columns
		if (!columns) return

		const aggregationModel = getAggregationModel(columns)
		setAggregationModel(isEmpty(aggregationModel) ? [] : aggregationModel)

		const rowGroupingModel = getRowGroupingModel(columns)
		setRowGroupingModel(isEmpty(rowGroupingModel) ? [] : rowGroupingModel)
	}, [columns])

	useEffect(() => {
		const handleColumnHeaderDragEnd = (params) => {
			const offset = hasManageRights ? 2 : 1
			const oldIndex = reorderingRef.current.oldIndex - offset + 1
			const targetIndex = reorderingRef.current.targetIndex - offset + 1
			;[gridColumns[oldIndex], gridColumns[targetIndex]] = [
				gridColumns[targetIndex],
				gridColumns[oldIndex],
			]

			let newColumns = [...cloneColumns]
			// switch position columns
			newColumns.splice(oldIndex - 1, 1)
			newColumns.splice(targetIndex - 1, 0, cloneColumns[oldIndex - 1])

			// Fix case dragging the column at the original position
			if (newColumns.filter(Boolean).length < cloneColumns.length) {
				newColumns = [...cloneColumns]
			}

			switch (tab) {
				case 'lookups':
					dispatch({
						type: LOOKUPS_ACTIONS.FORM_COLUMNS,
						payload: newColumns,
					})
					break
				case 'views':
					dispatch({
						type: VIEWS_ACTIONS.FORM_COLUMNS,
						payload: newColumns,
					})
					break
				case 'devices':
					dispatch({
						type: DEVICES_ACTIONS.FORM_COLUMNS,
						payload: newColumns,
					})
					break
				case 'activity':
					dispatch({
						type: ACTIVITY_ACTIONS.FORM_COLUMNS,
						payload: newColumns,
					})
					break
				default: // forms
					dispatch({
						type: FORM_ACTIONS.FORM_COLUMNS,
						payload: newColumns,
					})
					break
			}
			reorderingRef.current = {
				isDragging: false,
				oldIndex: null,
				targetIndex: null,
			}
			setHoverTrigger(false)
		}

		if (!apiRef?.current?.subscribeEvent || !hoverTrigger) return
		// The `subscribeEvent` method will automatically unsubscribe in the cleanup function of the `useEffect`.
		return apiRef?.current?.subscribeEvent('columnHeaderDragEnd', handleColumnHeaderDragEnd)
	}, [apiRef, hoverTrigger, cloneColumns])

	const actionField = () => {
		return {
			field: 'actions',
			type: 'actions',
			width: 75,
			disableReorder: true,
			getActions: (params) => {
				const title = [
					<>
						<Typography key={params.id} variant="body2">
							{params['row']['@displayId']}
						</Typography>
					</>,
				]
				const loading = [
					<Box sx={{ pl: 1.4, position: 'relative', top: '3px', left: '-6px' }}>
						<CircularProgress color="inherit" size={17} />
					</Box>,
				]
				let popupActions = [
					<GridActionsCellItem
						key={params.id}
						icon={<HistoryIcon />}
						label={t('common:misc.history')}
						onClick={handleAction(params, 'history', records, viewData)}
						showInMenu
					/>,
					<GridActionsCellItem
						key={params.id}
						icon={<FileCopyIcon />}
						label={t('common:misc.copy')}
						onClick={handleAction(params, 'copy', records, viewData)}
						showInMenu
					/>,
				]
				if (records && records[params.id - 1]?.type === 'DISPATCH') {
					let hasMap = false
					let hasRecall = false
					let hasSend = false
					// WFM-82 Please show the Recall option only for Scheduled, Sent, Received and Viewed.
					// WFM-82 Please show the Send option only for Pending, Scheduled and Sent.
					switch (records[params.id - 1].meta.status) {
						case 'Pending':
							//actions = ['audit', 'copy', 'delete', 'edit',                  'send', 'view']; break;
							hasSend = true
							break
						case 'Scheduled':
							//actions = ['audit', 'copy', 'delete', 'edit',                  'send', 'view']; break;
							hasSend = true
							hasRecall = true
							break
						case 'Emailed':
							//actions = ['audit', 'copy',                   'map',                   'view']; break;
							hasMap = true
							break
						case 'Messaged':
							//actions = ['audit', 'copy',                   'map',                   'view']; break;
							hasMap = true
							break
						case 'Sent':
							//actions = ['audit', 'copy',                   'map', 'recall', 'send', 'view']; break;
							hasMap = true
							hasRecall = true
							hasSend = true
							break
						case 'Received':
							//actions = ['audit', 'copy',                   'map', 'recall', 'send', 'view']; break;
							hasMap = true
							hasRecall = true
							// hasSend = true; //WFM-82 delete
							break
						case 'Opened':
							//actions = ['audit', 'copy',                   'map', 'recall',         'view']; break;
							hasMap = true
							// hasRecall = true; //WFM-82 delete
							break
						case 'Viewed':
							//actions = ['audit', 'copy',                   'map', 'recall', 'send', 'view']; break;
							hasMap = true
							hasRecall = true
							// hasSend = true; //WFM-82 delete
							break
						case 'Recalled':
							//actions = ['audit', 'copy',           'edit', 'map',                   'view']; break;
							hasMap = true
							break
						case 'Rejected':
							//actions = ['audit', 'copy', 'delete', 'edit', 'map',                   'view']; break;
							hasMap = true
							break
						case 'Acknowledged':
							//actions = ['audit', 'copy', 'delete', 'edit', 'map',                   'view']; break;
							hasMap = true
							break
						case 'Completed':
							//actions = ['audit', 'copy', 'delete', 'edit', 'map',                   'view']; break;
							hasMap = true
							break
						default:
							//actions = ['audit', 'copy', 'delete', 'edit', 'map', 'recall', 'send', 'view']; break;
							hasMap = true
							// hasRecall = true;  //WFM-82 delete
							// hasSend = true;  //WFM-82 delete
							break
					}
					if (hasMap) {
						popupActions = [
							...popupActions,
							<GridActionsCellItem
								key={params.id}
								icon={<MapIcon />}
								label={t('common:misc.map')}
								onClick={handleAction(params, 'map', records, viewData)}
								showInMenu
							/>,
						]
					}
					if (hasRecall) {
						popupActions = [
							...popupActions,
							<GridActionsCellItem
								key={params.id}
								icon={<ReplyIcon />}
								label={t('common:misc.recall')}
								onClick={handleAction(params, 'recall', records, viewData)}
								showInMenu
							/>,
						]
					}
					if (hasSend) {
						popupActions = [
							...popupActions,
							<GridActionsCellItem
								key={params.id}
								icon={<ReplyIcon style={{ transform: `scaleX(-1)` }} />}
								label={t('common:misc.send')}
								onClick={handleAction(params, 'send', records, viewData)}
								showInMenu
							/>,
						]
					}
				}

				const listOfNotShowEditAction = ['Sent', 'Received', 'Viewed']
				if (
					!environment.isReadOnlySubmission &&
					!listOfNotShowEditAction.includes(records?.[params.id - 1]?.meta?.status)
				) {
					popupActions = [
						...popupActions,
						<GridActionsCellItem
							key={params.id}
							icon={<EditIcon />}
							label={t('common:misc.edit')}
							onClick={handleAction(params, 'edit', records, viewData)}
							showInMenu
						/>,
					]
				}

				popupActions = [
					...popupActions,
					<GridActionsCellItem
						key={params.id}
						icon={<DeleteIcon />}
						label={t('common:misc.delete')}
						onClick={handleAction(params, 'delete', records, viewData)}
						showInMenu
					/>,
					<GridActionsCellItem
						key={params.id}
						icon={<VisibilityIcon />}
						label={t('common:misc.view')}
						onClick={handleAction(params, 'view', records, viewData)}
						showInMenu
					/>,
					<GridActionsCellItem
						key={params.id}
						icon={<PdfIcon />}
						label={'PDF'}
						onClick={handleAction(params, 'pdf', records, viewData)}
						showInMenu
					/>,
				]
				if (
					(records && records[params.id - 1]?.type === 'SUBMISSION') ||
					ACTIVITY_DEVICE_LIST.includes(viewData.type)
				) {
					popupActions = [
						...popupActions,
						<GridActionsCellItem
							key={params.id}
							icon={<ImageIcon />}
							label={t('common:misc.images')}
							onClick={handleAction(params, 'images', records, viewData)}
							showInMenu
						/>,
					]
				}

				const allActions = [
					...title,
					...(params?.row?.isLoading ? loading : []),
					...(!params?.row?.isLoading ? popupActions : []),
				]
				const AUTO_GENERATED_FOOTER_FROM_AGGREGATION = 'auto-generated-group-footer-root'

				// Remove the action menu icon from the aggregate row
				if (params?.id === AUTO_GENERATED_FOOTER_FROM_AGGREGATION) {
					return []
				}

				return allActions
			},
		}
	}

	const hasMoreRecords = useMemo(() => queryView.more, [queryView])

	const showLoadAllRecordsButton = (isFooter) => {
		if (!hasMoreRecords) return null
		return (
			<div className={isFooter ? classes.loadAllFooter : classes.loadAllToolbar}>
				{!allRecordsLoading && (
					<LoadingButton
						id="load-all-records"
						className={classes.loadAllIcon}
						startIcon={<KeyboardTabIcon />}
						loadingPosition="start"
						variant={'text'}
						onClick={() => {
							if (isLoading || allRecordsLoading) {
								setInfo(t('common:misc.pleaseWaitMoment'))
							} else {
								onHandledLoadAllRecords()
							}
						}}
					>
						{t('common:misc.loadAllRecords')}
					</LoadingButton>
				)}
				{allRecordsLoading && (
					<Button
						id="cancel-loading-records"
						className={classes.cancelLoadingIcon}
						startIcon={<CircularProgress color="inherit" size={16} />}
						loadingPosition="start"
						variant={'text'}
						onClick={() => onHandledCancelLoadingRecords()}
					>
						{t('common:misc.cancelLoadingRecords')}
					</Button>
				)}
			</div>
		)
	}

	const showTitleFooter = () => {
		return <div className={classes.titleFooter}>{titleFooter}</div>
	}

	const onColumnsReordered = (params) => {
		reorderingRef.current = reorderingRef.current.isDragging
			? { ...reorderingRef.current, targetIndex: params.targetIndex }
			: {
					isDragging: true,
					oldIndex: params.oldIndex,
					targetIndex: params.targetIndex,
			  }
	}

	const onColumnsWidthChanged = (params) => {
		const { colDef } = params
		onHandledResizeColumn(colDef.field, colDef.width)
	}

	const handleChangeRowsPerPage = (size) => {
		switch (tab) {
			case 'lookups':
				dispatch({
					type: LOOKUPS_ACTIONS.ROWS_PER_PAGE,
					payload: size,
				})
				break
			case 'views':
				dispatch({
					type: VIEWS_ACTIONS.ROWS_PER_PAGE,
					payload: size,
				})
				break
			case 'devices':
				dispatch({
					type: DEVICES_ACTIONS.ROWS_PER_PAGE,
					payload: size,
				})
				break
			case 'activity':
				dispatch({
					type: ACTIVITY_ACTIONS.ROWS_PER_PAGE,
					payload: size,
				})
				break
			default:
				dispatch({
					type: FORM_ACTIONS.ROWS_PER_PAGE,
					payload: size,
				})
				break
		}
	}

	const handleAction = useCallback(
		(params, action, records, viewData) => async () => {
			try {
				let record = records[params.id - 1]
				record = {
					...record,
					key:
						record.sourceType === 'SUBMISSION' || record.sourceType === 'ACTIVITY'
							? record.submissionKey
							: record.dispatchKey,
				}
				if (
					['copy', 'edit'].includes(action) &&
					(ACTIVITY_DEVICE_LIST.includes(viewData.type) || 'activityKey' in record)
				) {
					if (tab === 'devices') {
						dispatch({
							type: DEVICES_ACTIONS.OLD_FORM_SELECTED,
							payload: formSelected,
						})
					} else if (tab === 'views') {
						dispatch({
							type: VIEWS_ACTIONS.OLD_VIEW_SELECTED_KEY,
							payload: formSelected.key,
						})
					}

					setActionRecord(record)
					const response = await getFormSelectedFromActivityKey(
						record.activityKey,
						environment.apiToken
					)
					const currentFormSelected = response.data
					if (Object.keys(currentFormSelected).length > 0) {
						switch (tab) {
							case 'views':
								dispatch({
									type: VIEWS_ACTIONS.UPDATE_VIEW_SELECTED_KEY,
									payload: currentFormSelected.formKey,
								})
								break
							case 'devices':
								dispatch({
									type: DEVICES_ACTIONS.FORM_SELECTED,
									payload: currentFormSelected,
								})
								break
							case 'activity':
								dispatch({
									type: ACTIVITY_ACTIONS.FORM_SELECTED,
									payload: currentFormSelected,
								})
								break
							default:
								break
						}
						setAction(action)
						setOpen(action !== 'images' ? true : false)
					}
				} else {
					switch (action) {
						case 'map':
							switch (tab) {
								case 'lookups':
									dispatch({
										type: LOOKUPS_ACTIONS.ACTION,
										payload: action,
									})
									break
								case 'views':
									dispatch({
										type: VIEWS_ACTIONS.ACTION,
										payload: action,
										showMapCloseIcon: true,
									})
									break
								case 'devices':
									dispatch({
										type: DEVICES_ACTIONS.ACTION,
										payload: action,
										showMapCloseIcon: true,
									})
									break
								case 'activity':
									dispatch({
										type: ACTIVITY_ACTIONS.ACTION,
										payload: action,
										showMapCloseIcon: true,
									})
									break
								default:
									dispatch({
										type: FORM_ACTIONS.ACTION,
										payload: action,
										dispatchRecord: record,
										showMapCloseIcon: true,
									})
									break
							}
						default:
							setAction(action)
							setActionRecord(record)
							setOpen(action !== 'images' ? true : false)
					}
				}
			} catch (err) {
				if (err?.response?.data?.code === 404) {
					setError(`${t('common:misc.record')} ${t('common:misc.hasBeenDeleted')}`)
				} else {
					setError('Code ' + err?.response?.data?.code + ': ' + err?.response?.data?.message)
				}
			}
		},
		[action]
	)

	const handleClose = () => {
		setAction(null)
		setActionRecord(null)
		setOpen(false)
		setOpenGalleryView(false)
	}

	const handleCallbackRecordsActions = ({ galleryView }) => {
		setOpenGalleryView(galleryView)
	}

	const CustomFooter = () => (
		<GridFooterContainer>
			<div className={classes.gridFooterActions}>
				{!isEmpty(titleFooter) && <>{showTitleFooter()}</>}
				{!isEmpty(viewData) && <>{showLoadAllRecordsButton(true)}</>}
			</div>

			<CustomPagination
				hasMoreRecords={hasMoreRecords}
				onHandleLoadRecordsByPagination={onHandleLoadRecordsByPagination}
				setPaginationModel={setPaginationModel}
				isLoading={isLoading}
				allRecordsLoading={allRecordsLoading}
				showInfoMessage={() => setInfo(t('common:misc.pleaseWaitMoment'))}
				setScrollPosition={() => {
					if (isEmpty(gridRef?.current)) return

					const scrollBarEl = gridRef?.current?.querySelector('.MuiDataGrid-scrollbar')
					if (scrollBarEl) {
						scrollBarEl.scrollTo({ top: 0, behavior: 'smooth' })
					}
				}}
			/>
		</GridFooterContainer>
	)

	const getGridRowIDs = (apiRef) => {
		if (!apiRef) {
			return []
		}

		const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef)

		let gridRowIDsTmp = []
		for (var i = 0; i < gridRows.length; i++) {
			gridRowIDsTmp.push(-1)
		}

		filteredSortedRowIds.forEach((id, index) => {
			gridRowIDsTmp[id - 1] = index + 1
		})

		var index = filteredSortedRowIds.length + 1
		for (var i = 0; i < gridRowIDsTmp.length; i++) {
			if (gridRowIDsTmp[i] == -1) {
				gridRowIDsTmp[i] = index
				index++
			}
		}
		return gridRowIDsTmp
	}

	const getFilteredDataIDs = (apiRef) => {
		return gridFilteredSortedRowIdsSelector(apiRef)
	}

	const handleGoToHelpLink = () => {
		window.open(HELP_LINK_CONDITION_FILTERS, '_blank')
	}

	const onHandleOpenFullScreenTab = () => {
		switch (tab) {
			case 'forms':
				onHandleOpenFullScreenFormsTab()
				break
			case 'views':
				onHandleOpenFullScreenViewsTab()
				break
			case 'lookups':
				onHandleOpenFullScreenLookupsTab()
				break
			case 'devices':
				onHandleOpenFullScreenDevicesTab()
				break
			case 'activity':
				onHandleOpenFullScreenDevicesTab()
				break
			default:
				break
		}
	}

	const handleImportComplete = () => {
		switch (tab) {
			case 'lookups':
				dispatch({
					type: LOOKUPS_ACTIONS.LOOKUPS_REFRESH,
					payload: true,
				})
				break
			case 'views':
				dispatch({
					type: VIEWS_ACTIONS.VIEW_REFRESH,
					payload: true,
				})
				break
			case 'devices':
				dispatch({
					type: DEVICES_ACTIONS.DEVICE_REFRESH,
					payload: true,
				})
				break
			case 'activity':
				dispatch({
					type: ACTIVITY_ACTIONS.ACTIVITY_REFRESH,
					payload: true,
				})
				break
			default:
				dispatch({
					type: FORM_ACTIONS.FORM_REFRESH,
					payload: true,
				})
				break
		}
	}

	const handleOpen = (e) => {
		dispatch({
			type: ENV_ACTIONS.SHOW_SEND_DISPATCH,
			payload: 'dashboard',
		})
	}

	const handleShowChart = () => {
		if (viewData.chart) {
			viewData.chart.display = !viewData.chart.display
		}
		setTriggerShowChart((prev) => !prev)
	}

	const renderTitle = () => (
		<UpdateAlert
			isFormDeleted={isFormDeleted}
			formSelected={formSelected}
			isRefresh={isRefresh}
			viewData={viewData}
			queryView={queryView}
			deviceSelected={deviceSelected}
			tab={tab}
			onHandlePresetReloadAll={onHandlePresetReloadAll}
			onHandleReLoadFirstPage={onHandleReLoadFirstPage}
		>
			<Typography variant="h6" className={classes.headingLabel}>
				{title || ''}
			</Typography>
		</UpdateAlert>
	)

	const isValidDate = (d) => {
		return d instanceof Date && !isNaN(d)
	}

	const onHandleFilters = (params, xAxisSelected, dateGroupSelected) => {
		if (params == null) return
		setParamSave({ ...params, xAxisSelected: xAxisSelected, dateGroupSelected: dateGroupSelected })
	}

	function onEditChart(newChartSetting) {
		const newViewData = cloneDeep(viewData)
		if (tab === VIEW.VIEW_TAB_LOOKUPS) {
			dispatch({
				type: LOOKUPS_ACTIONS.VIEW_DATA,
				payload: { ...newViewData, chart: newChartSetting },
			})
		} else if ([VIEW.VIEW_TAB_VIEWS].includes(tab)) {
			dispatch({
				type: VIEWS_ACTIONS.VIEW_DATA,
				payload: { ...newViewData, chart: newChartSetting },
			})
		} else if (tab === VIEW.VIEW_TAB_DEVICES) {
			dispatch({
				type: DEVICES_ACTIONS.VIEW_DATA,
				payload: { ...newViewData, chart: newChartSetting },
			})
		} else if (tab === 'activity') {
			dispatch({
				type: ACTIVITY_ACTIONS.VIEW_DATA,
				payload: { ...newViewData, chart: newChartSetting },
			})
		} else {
			dispatch({
				type: FORM_ACTIONS.VIEW_DATA,
				payload: { ...newViewData, chart: newChartSetting },
			})
		}
	}

	const renderChart = useCallback(() => {
		if (!viewData?.chart?.display) return null
		return (
			<DoformsChartGrid
				id={'DoformsDataGridChart'}
				formMapRef={formMapRef}
				environment={environment}
				columns={columns}
				tab={tab}
				gridRows={gridRows}
				recordsLoading={recordsLoading}
				chartSetting={viewData?.chart || {}}
				setChartSetting={(newChartSetting) => onEditChart(newChartSetting)}
				onHandleFilters={onHandleFilters}
			/>
		)
	}, [gridRows, viewData])

	const defaultLabelDisplayedRows = ({ from, to, count }) => {
		return `${from}–${to} ${t('common:misc.of')} ${
			count !== -1 ? count : `${t('common:misc.moreThan')} ${to}`
		}`
	}

	const handleFilterModelChange = debounce((newFilterModel) => {
		if (!canChangeFilter) {
			setAlertInfo((prev) => ({
				...prev,
				open: true,
				type: 'error',
				text: "You don't have permission to change filter",
			}))
			return
		}

		const newFilterWithoutEmptyValue = newFilterModel.items.filter(
			// Get value undefined because it is the new filter item
			(item) => item.value !== '' || item.value === undefined
		)

		switch (tab) {
			case 'lookups':
				dispatch({
					type: LOOKUPS_ACTIONS.CLIENT_FILTERS,
					payload: {
						...clientFilters,
						[clientFilterKey]: newFilterWithoutEmptyValue,
					},
				})
				break
			case 'views':
				dispatch({
					type: VIEWS_ACTIONS.CLIENT_FILTERS,
					payload: {
						...clientFilters,
						[clientFilterKey]: newFilterWithoutEmptyValue,
					},
				})
				break
			case 'devices':
				dispatch({
					type: DEVICES_ACTIONS.CLIENT_FILTERS,
					payload: {
						...clientFilters,
						[clientFilterKey]: newFilterWithoutEmptyValue,
					},
				})
				break
			case 'activity':
				dispatch({
					type: ACTIVITY_ACTIONS.CLIENT_FILTERS,
					payload: {
						...clientFilters,
						[clientFilterKey]: newFilterWithoutEmptyValue,
					},
				})
				break
			default: //FORMS
				dispatch({
					type: FORM_ACTIONS.CLIENT_FILTERS,
					payload: {
						...clientFilters,
						[clientFilterKey]: newFilterWithoutEmptyValue,
					},
				})
				break
		}
	}, 500)

	const makeFilterModel = () => {
		let xAxisValue = paramSave.name
		let xAxisSelected = paramSave.xAxisSelected
		let dateGroupSelected = paramSave.dateGroupSelected

		let removeFilterValue = null
		if (clientFiltersMemo?.items?.length > 0) {
			removeFilterValue = clientFiltersMemo?.items?.[0]?.value
		}
		const selectedFiled = gridColumns.filter((col) => col.field == xAxisSelected)
		if (selectedFiled.length <= 0) return
		let operator = ''
		let filterItems = []
		let arr
		let dateObj
		let momentObjStart, momentObjEnd
		switch (selectedFiled[0].type.toUpperCase()) {
			case 'DATETIME':
			case 'DATE':
				arr = xAxisValue.split('/')
				if (arr.length == 1) {
					dateObj = new Date(arr[0] + '-01-01T00:00')
					if (!isValidDate(dateObj)) break
					momentObjStart = moment(dateObj)
					momentObjEnd = moment(dateObj).add(1, 'years')
				} else if (arr.length == 2) {
					dateObj = new Date(arr[1] + '-' + arr[0] + '-01T00:00')
					if (!isValidDate(dateObj)) break
					momentObjStart = moment(dateObj)
					momentObjEnd = moment(dateObj).add(1, 'months')
				} else if (arr.length == 3) {
					dateObj = new Date(arr[2] + '-' + arr[0] + '-' + arr[1] + 'T00:00')
					if (!isValidDate(dateObj)) break
					momentObjStart = moment(dateObj)
					if (dateGroupSelected == 'week') {
						momentObjEnd = moment(dateObj).add(1, 'weeks')
					} else {
						momentObjEnd = moment(dateObj).add(1, 'days')
					}
				} else {
					break
				}
				if (removeFilterValue == momentObjStart.format('YYYY-MM-DDTHH:mm')) {
					filterItems.push({
						field: xAxisSelected,
						operator: 'onOrAfter',
					})
				} else {
					filterItems.push({
						id: 1,
						field: xAxisSelected,
						operator: 'onOrAfter',
						value: momentObjStart.format('YYYY-MM-DDTHH:mm'),
					})
					filterItems.push({
						id: 2,
						field: xAxisSelected,
						operator: 'before',
						value: momentObjEnd.format('YYYY-MM-DDTHH:mm'),
					})
				}

				break
			case 'TIME':
				filterItems.push({
					field: xAxisSelected,
					operator: 'is',
				})
				break
			case 'NUMBER':
				operator = '='
				if (removeFilterValue == xAxisValue) {
					filterItems.push({
						field: xAxisSelected,
						operator: operator,
					})
				} else {
					filterItems.push({
						field: xAxisSelected,
						operator: operator,
						value: xAxisValue,
					})
				}
				break
			default:
				operator = 'equals'
				if (removeFilterValue == xAxisValue) {
					filterItems.push({
						field: xAxisSelected,
						operator: operator,
					})
				} else {
					filterItems.push({
						field: xAxisSelected,
						operator: operator,
						value: xAxisValue,
					})
				}
		}

		handleFilterModelChange({
			items: filterItems,
		})
	}

	const handleStateChange = (newRows) => {
		let filteredDataIDs = getFilteredDataIDs(apiRef)
		if (
			newRows.length == filteredDataIDs.length &&
			JSON.stringify(newRows) == JSON.stringify(newRows)
		) {
			if (newRows.length != 0) {
				let dontUpdateFlag = true
				newRows.forEach((item, index) => {
					if (gridRowIDs[item - 1] != index + 1) {
						dontUpdateFlag = false
						return false
					}
				})
				if (!dontUpdateFlag) {
					setUpdateGridRowIDSs(true)
				}
			} else if (gridRowIDs && gridRowIDs.length > 0) {
				setGridRowIDs([])
			}
		}
	}

	const formattedRowsWithNumbers = useMemo(() => {
		if (!gridRows.length) return []

		return gridRows.map((row) => {
			// loop through property of row and find data with number type
			// then format it to have number
			const rowWithFormatValue = {}
			Object.keys(row).forEach((key) => {
				rowWithFormatValue[key] = row[key]
			})
			return rowWithFormatValue
		})
	}, [gridRows])

	const formatGridColumns = useMemo(() => {
		return [
			actionField(),
			...gridColumns.filter(Boolean).map((column) => {
				if (!column.field) return column
				switch (column.field) {
					case 'Description':
						column.title = t('common:misc.description')
						column.headerName = t('common:misc.description')
						break
					case '@StartTime':
						column.title = t('common:misc.startTime')
						column.headerName = t('common:misc.startTime')
						break
					case '@SourceName':
						column.title = t('common:misc.sourceName')
						column.headerName = t('common:misc.sourceName')
						break
					case '@OwnerName':
						column.title = t('common:misc.ownerName')
						column.headerName = t('common:misc.ownerName')
						break
					case '@UserStatus':
						column.title = t('common:misc.userStatus')
						column.headerName = t('common:misc.userStatus')
						break
					case '@StatusTime':
						column.title = t('common:misc.statusTime')
						column.headerName = t('common:misc.statusTime')
						break
					default:
						break
				}

				// Disable aggregation for non-number columns
				if (column?.format?.useGrouping === undefined) {
					return {
						...column,
						aggregable: false,
					}
				}

				// Convert to number if value is number to enable aggregation
				if (column?.format?.useGrouping !== undefined) {
					return {
						...column,
						type: 'number',
					}
				}

				return column
			}),
		]
	}, [gridColumns, records, viewData, handleAction])

	const renderGrid = () => {
		if (!showGrid || gridColumns.length === 0) return null

		if (paramSave != null) {
			makeFilterModel()
			setParamSave(null)
			return
		}

		return (
			<DataGridPremium
				sx={{
					height: 'auto !important',
					'@media print': {
						'.echarts-for-react ': { display: 'none' },
					},
					'& .MuiDataGrid-columnHeaderTitleContainerContent': {
						mb: '10px !important',

						'& .MuiDataGrid-aggregationColumnHeaderLabel ': {
							position: hasAggregationModel ? 'relative' : 'absolute',
						},
					},
				}}
				ref={gridRef}
				// initialState={filters}
				filterModel={
					!isEmpty(clientFiltersMemoWithoutColumnField)
						? {
								items: clientFiltersMemoWithoutColumnField,
						  }
						: undefined
				}
				onFilterModelChange={handleFilterModelChange}
				componentsProps={{
					pagination: {
						labelRowsPerPage: t('common:misc.rowsPerPage'),
						labelDisplayedRows: ({ from, to, count }) =>
							defaultLabelDisplayedRows({ from, to, count }),
					},
				}}
				localeText={{
					// Root
					noRowsLabel: t('common:misc.noRows'),
					noResultsOverlayLabel: t('common:misc.noResultsOverlayLabel'),
					errorOverlayDefaultLabel: t('common:misc.errorOverlayDefaultLabel'),

					// Density selector toolbar button text
					toolbarDensity: t('common:misc.style'),
					toolbarDensityLabel: t('common:misc.style'),
					toolbarDensityCompact: t('common:misc.densityCompact'),
					toolbarDensityStandard: t('common:misc.densityStandard'),
					toolbarDensityComfortable: t('common:misc.densityComfortable'),

					// Columns selector toolbar button text
					toolbarColumns: t('common:misc.columns'),
					toolbarColumnsLabel: t('common:misc.columnsLabel'),

					// Filters toolbar button text
					toolbarFilters: t('common:misc.filters'),
					toolbarFiltersLabel: t('common:misc.filtersLabel'),
					toolbarFiltersTooltipHide: t('common:misc.filtersTooltipHide'),
					toolbarFiltersTooltipShow: t('common:misc.filtersTooltipShow'),
					toolbarFiltersTooltipActive: (count) =>
						count > 1
							? `${count} ${t('common:misc.filtersTooltipActive')}`
							: `${count} ${t('common:misc.filterTooltipActive')}`,

					// Quick filter toolbar field
					toolbarQuickFilterPlaceholder: t('common:misc.quickFilterPlaceholder'),
					toolbarQuickFilterLabel: t('common:misc.quickFilterLabel'),
					toolbarQuickFilterDeleteIconLabel: t('common:misc.quickFilterDeleteIconLabel'),

					// Export selector toolbar button text
					toolbarExport: t('common:misc.export'),
					toolbarExportLabel: t('common:misc.exportLabel'),
					toolbarExportCSV: t('common:misc.exportCSV'),
					toolbarExportPrint: t('common:misc.exportPrint'),
					toolbarExportExcel: t('common:misc.exportExcel'),

					// Columns panel text
					columnsPanelTextFieldLabel: t('common:misc.columnsPanelTextFieldLabel'),
					columnsPanelTextFieldPlaceholder: t('common:misc.columnsPanelTextFieldPlaceholder'),
					columnsPanelDragIconLabel: t('common:misc.columnsPanelDragIconLabel'),
					columnsPanelShowAllButton: t('common:misc.columnsPanelShowAllButton'),
					columnsPanelHideAllButton: t('common:misc.columnsPanelHideAllButton'),

					// Filter panel text
					filterPanelAddFilter: t('common:misc.addFilter'),
					filterPanelDeleteIconLabel: t('common:misc.deleteIconLabel'),
					filterPanelLinkOperator: t('common:misc.filterPanelLinkOperator'),
					filterPanelOperators: t('common:misc.operations'),
					filterPanelOperatorAnd: t('common:misc.filterPanelOperatorAnd'),
					filterPanelOperatorOr: t('common:misc.filterPanelOperatorOr'),
					filterPanelColumns: t('common:misc.filterPanelFields'),
					filterPanelInputLabel: t('common:misc.filterPanelInputLabel'),
					filterPanelInputPlaceholder: t('common:misc.filterPanelInputPlaceholder'),

					// Filter operators text
					filterOperatorContains: t('common:misc.operatorContains'),
					filterOperatorEquals: t('common:misc.operatorEquals'),
					filterOperatorStartsWith: t('common:misc.operatorStartsWith'),
					filterOperatorEndsWith: t('common:misc.operatorEndsWith'),
					filterOperatorIs: t('common:misc.operatorIs'),
					filterOperatorNot: t('common:misc.operatorNot'),
					filterOperatorAfter: t('common:misc.operatorAfter'),
					filterOperatorOnOrAfter: t('common:misc.operatorOnOrAfter'),
					filterOperatorBefore: t('common:misc.operatorBefore'),
					filterOperatorOnOrBefore: t('common:misc.operatorOnOrBefore'),
					filterOperatorIsEmpty: t('common:misc.operatorIsEmpty'),
					filterOperatorIsNotEmpty: t('common:misc.operatorIsNotEmpty'),
					filterOperatorIsAnyOf: t('common:misc.operatorIsAnyOf'),

					// Filter values text
					filterValueAny: t('common:misc.valueAny'),
					filterValueTrue: t('common:misc.valueTrue'),
					filterValueFalse: t('common:misc.valueFalse'),

					// Column menu text
					columnMenuLabel: t('common:misc.columnMenuLabel'),
					columnMenuShowColumns: t('common:misc.columnMenuShowColumns'),
					columnMenuFilter: t('common:misc.columnMenuFilter'),
					columnMenuHideColumn: t('common:misc.columnMenuHideColumn'),
					columnMenuUnsort: t('common:misc.columnMenuUnsort'),
					columnMenuSortAsc: t('common:misc.columnMenuSortAsc'),
					columnMenuSortDesc: t('common:misc.columnMenuSortDesc'),

					// Column header text
					columnHeaderFiltersTooltipActive: (count) =>
						count !== 1
							? `${count} ${t('common:misc.columnHeaderFiltersTooltipActive')}`
							: `${count} ${t('common:misc.columnHeaderFilterTooltipActive')}`,
					columnHeaderFiltersLabel: t('common:misc.columnHeaderFiltersLabel'),
					columnHeaderSortIconLabel: t('common:misc.columnHeaderSortIconLabel'),

					// Rows selected footer text
					footerRowSelected: (count) =>
						count !== 1
							? `${count.toLocaleString()} ${t('common:misc.footerRowsSelected')}`
							: `${count.toLocaleString()} ${t('common:misc.footerRowSelected')}`,

					// Total row amount footer text
					footerTotalRows: t('common:misc.footerTotalRows'),

					// Total visible row amount footer text
					footerTotalVisibleRows: (visibleCount, totalCount) =>
						`${visibleCount.toLocaleString()} ${t(
							'common:misc.footerTotalVisibleRowsOf'
						)} ${totalCount.toLocaleString()}`,

					// Checkbox selection text
					checkboxSelectionHeaderName: t('common:misc.checkboxSelectionHeaderName'),
					checkboxSelectionSelectAllRows: t('common:misc.checkboxSelectionSelectAllRows'),
					checkboxSelectionUnselectAllRows: t('common:misc.checkboxSelectionUnselectAllRows'),
					checkboxSelectionSelectRow: t('common:misc.checkboxSelectionSelectRow'),
					checkboxSelectionUnselectRow: t('common:misc.checkboxSelectionUnselectRow'),

					// Boolean cell text
					booleanCellTrueLabel: t('common:misc.booleanCellTrueLabel'),
					booleanCellFalseLabel: t('common:misc.booleanCellFalseLabel'),

					// Actions cell more text
					actionsCellMore: t('common:misc.actionsCellMore'),

					// Column pinning text
					pinToLeft: t('common:misc.pinToLeft'),
					pinToRight: t('common:misc.pinToRight'),
					unpin: t('common:misc.unpin'),

					// Tree Data
					treeDataGroupingHeaderName: t('common:misc.treeDataGroupingHeaderName'),
					treeDataExpand: t('common:misc.treeDataExpand'),
					treeDataCollapse: t('common:misc.treeDataCollapse'),

					// Grouping columns
					groupingColumnHeaderName: t('common:misc.groupingColumnHeaderName'),
					groupColumn: (name) => `${t('common:misc.groupColumn')} ${name}`,
					unGroupColumn: (name) => `${t('common:misc.unGroupColumn')} ${name}`,

					// Master/detail
					detailPanelToggle: t('common:misc.detailPanelToggle'),
					expandDetailPanel: t('common:misc.expandDetailPanel'),
					collapseDetailPanel: t('common:misc.collapseDetailPanel'),

					// Used core components translation keys

					// Row reordering text
					rowReorderingHeaderName: t('common:misc.rowReorderingHeaderName'),
				}}
				className={`${classes.root} ${gridRows.length > 0 ? 'grid-loaded' : ''}`}
				apiRef={apiRef}
				slots={{
					footer: CustomFooter,
					toolbar: CustomToolbar,
				}}
				slotProps={{
					panel: {
						sx: {
							'& .MuiDataGrid-panelContent': {
								overflowX: 'hidden',
							},
						},
					},
					toolbar: {
						formMapRef,
						recordsLoading,
						environment,
						viewData,
						gridColumns,
						queryView,
						tab,
						formSelected,
						handleImportComplete,
						gridRows,
						records,
						columns,
						hasManageRights,
						rowGroupingModel,
						aggregationModel,
						isLoading,
						allRecordsLoading,
						setInfo,
						handleOpen,
						selectionModel,
						handleShowChart,
						handleGoToHelpLink,
						onHandleOpenFullScreenTab,
						renderChart,
						showLoadAllRecordsButton,
						canChangeFilter,
						formattedRowsWithNumbers,
						formatGridColumns,
						sortModel,
						apiRef,
						hasMoreRecords,
						onHandledLoadAllRecords,
						onHandledCancelLoadingRecords,
					},
				}}
				columns={formatGridColumns}
				onError={() => {
					console.log('error')
				}}
				onColumnHeaderEnter={() => setHoverTrigger(true)}
				onColumnOrderChange={onColumnsReordered}
				disableColumnReorder={isLoading || allRecordsLoading ? true : false}
				onColumnWidthChange={onColumnsWidthChanged}
				rows={formattedRowsWithNumbers}
				density={'compact'}
				pagination
				pageSizeOptions={PAGE_SIZE_LIST}
				paginationModel={paginationModel}
				onPaginationModelChange={setPaginationModel}
				columnHeader={'alignLeft'}
				checkboxSelection={hasManageRights}
				onRowSelectionModelChange={(newRowModesModel) => {
					setSelectionModel(newRowModesModel)
				}}
				rowSelectionModel={selectionModel}
				disableRowSelectionOnClick
				onStateChange={(state, event, details) => {
					const newRows = gridSortedRowIdsSelector(state)
					if (newRows && gridRows) {
						//setUpdateGridRowIDSs(true);
						handleStateChange(newRows)
					}
					if (density != state?.density?.value) {
						setDensity(state?.density?.value)
					}
				}}
				pageSize={rowsPerPage ?? 100}
				onPageSizeChange={handleChangeRowsPerPage}
				loading={recordsLoading}
				aggregationModel={aggregationModel}
				onAggregationModelChange={(newModel) => setAggregationModel(newModel)}
				rowGroupingModel={rowGroupingModel}
				onRowGroupingModelChange={(model) => setRowGroupingModel(model)}
				sortModel={sortModel}
				onSortModelChange={(model, details) => {
					setSortModel([...model])
				}}
			/>
		)
	}

	return (
		<>
			<ToastAlert alertInfo={alertInfo} setAlertInfo={setAlertInfo} />
			{showInfoMessage(info)}
			{!isEmpty(viewData) && (
				<>
					{tab !== 'devices' && renderTitle()}
					{!openGalleryView && (
						<div className={classes.gridContainer}>
							{tab !== 'lookups' && (
								<div className={classes.subheader}>
									<DoformsConditionFilters
										environment={environment}
										query={query}
										viewData={viewData}
										columns={columns}
										queryView={queryView}
										tab={tab}
										recordsLoading={recordsLoading}
										onHandleOpenFullScreenTab={onHandleOpenFullScreenTab}
									/>
									{showLoadAllRecordsButton(false)}
								</div>
							)}
							{renderGrid()}
						</div>
					)}
				</>
			)}
			{action && (
				<DoformsRecordsActions
					setIsFormDeleted={setIsFormDeleted}
					setGridRows={setGridRows}
					setExternalError={setError}
					viewTitle={viewTitle}
					popupTitle={title}
					open={open}
					action={action}
					setAction={setAction}
					environment={environment}
					actionRecord={actionRecord}
					formSelected={formSelected}
					name={viewData.name}
					tab={tab}
					columns={columns}
					onClose={handleClose}
					onCallback={handleCallbackRecordsActions}
					setLoading={setLoading}
				/>
			)}
		</>
	)
}

const CustomToolbar = (props) => {
	const {
		formMapRef,
		recordsLoading,
		environment,
		viewData,
		gridColumns,
		queryView,
		tab,
		formSelected,
		handleImportComplete,
		gridRows,
		records,
		columns,
		clientFiltersMemo,
		hasManageRights,
		aggregationModel,
		rowGroupingModel,
		sortModel,
		isLoading,
		allRecordsLoading,
		setInfo,
		handleOpen,
		selectionModel,
		handleShowChart,
		handleGoToHelpLink,
		onHandleOpenFullScreenTab,
		renderChart,
		canChangeFilter,
		formattedRowsWithNumbers,
		formatGridColumns,
		apiRef,
		hasMoreRecords,
		onHandledLoadAllRecords,
		onHandledCancelLoadingRecords,
	} = props

	const [t] = useTranslation('common')
	const { iconTheme } = useContext(IconThemeContext)
	const classes = useStyles(iconTheme)
	const dispatch = useDispatch()

	return (
		<div ref={formMapRef}>
			<GridToolbarContainer
				sx={{
					'& .MuiButton-root': {
						color: environment.iconsTheme[0],
						':hover': {
							color: environment.iconsTheme[1],
							backgroundColor: 'transparent',
						},
					},
				}}
			>
				<DoformsDataColumns
					isLoading={isLoading || allRecordsLoading}
					setInfo={setInfo}
					environment={environment}
					viewData={viewData}
					columns={columns}
					tab={tab}
					recordsLoading={recordsLoading}
					disabled={!canChangeFilter}
				/>
				<GridToolbarFilterButton sx={environment.iconsTheme} />
				<GridToolbarDensitySelector sx={environment.iconsTheme} />
				{!environment.isReadOnlySubmission && !ACTIVITY_DEVICE_LIST.includes(viewData.type) && (
					<DoformsDataImportView
						environment={environment}
						gridColumns={gridColumns}
						viewData={viewData}
						queryView={queryView}
						tab={tab}
						recordsLoading={recordsLoading}
						formSelected={formSelected}
						onHandleImportComplete={handleImportComplete}
					/>
				)}
				<ExportButton
					sx={environment.iconsTheme}
					viewData={viewData}
					gridRows={gridRows}
					gridColumns={gridColumns}
					records={records}
					aggregationModel={aggregationModel}
					sortModel={sortModel}
					rowGroupingModel={rowGroupingModel}
					formattedRowsWithNumbers={formattedRowsWithNumbers}
					formatGridColumns={formatGridColumns}
					getVisibleRows={() => {
						const paginationRowModels = gridPaginatedVisibleSortedGridRowEntriesSelector(apiRef)
						let rs = []
						paginationRowModels.forEach((rowModel, index) => {
							const a = rowModel.model
							// a.id = index + 1
							rs.push(a)
						})
						return rs
					}}
					hasMoreRecords={hasMoreRecords}
					dataLoading={isLoading || allRecordsLoading}
					onHandledLoadAllRecords={onHandledLoadAllRecords}
					onHandledCancelLoadingRecords={onHandledCancelLoadingRecords}
				/>
				<DoformsDataGridRefresh
					isLoading={isLoading || allRecordsLoading}
					setInfo={setInfo}
					recordsLoading={recordsLoading}
					tab={tab}
				/>
				{!environment.isReadOnlySubmission &&
					['forms', 'lookups'].includes(tab) &&
					!formSelected.abandoned && (
						<DoformsCreateSubmission recordsLoading={recordsLoading} source={'grid'} />
					)}
				{['forms'].includes(tab) && !formSelected.abandoned && (
					<LoadingButton
						id={'send-dispatch'}
						className={classes.icon}
						disabled={recordsLoading}
						loadingPosition="start"
						onClick={(e) => handleOpen(e)}
						startIcon={<ShortcutIcon />}
					>
						{t('common:filters.dispatch')}
					</LoadingButton>
				)}
				<DoformsDataSaveView
					clientFilter={clientFiltersMemo}
					hasManageRights={hasManageRights}
					environment={environment}
					owners={environment.owners}
					gridColumns={gridColumns}
					viewData={viewData}
					queryView={queryView}
					tab={tab}
					recordsLoading={recordsLoading}
					aggregationModel={aggregationModel}
					rowGroupingModel={rowGroupingModel}
				/>
				{['views'].includes(tab) && (
					<DoformsDataViewDelete
						environment={environment}
						view={formSelected}
						recordsLoading={recordsLoading}
						source={'grid'}
					/>
				)}
				{selectionModel?.length > 0 && (
					<DoformsMultiSelectDelete
						environment={environment}
						records={records}
						selections={selectionModel}
						tab={tab}
					/>
				)}
				<LoadingButton
					hidden={
						records?.length === 0 ||
						(!viewData?.chart?.xAxis?.length && !viewData?.chart?.yAxis?.length)
					}
					className={classes.icon}
					loadingPosition="start"
					disabled={recordsLoading}
					onClick={handleShowChart}
					startIcon={<InsertChartIcon />}
				>
					{viewData?.chart?.display ? t('common:misc.hideChart') : t('common:misc.showChart')}
				</LoadingButton>
				<DoformsDataChart
					hidden={
						records?.length > 0 &&
						(viewData?.chart?.xAxis?.length || viewData?.chart?.yAxis?.length)
					}
					isAddChart
					showOnlyChart={false}
					columns={columns}
					tab={tab}
					gridRows={gridRows}
					recordsLoading={recordsLoading}
					viewData={viewData}
					environment={environment}
				/>
				{tab === 'lookups' && (
					<IconButton
						sx={environment.iconsTheme}
						aria-describedby={'help link'}
						className={classes.conditionBuild}
						onClick={handleGoToHelpLink}
						size="small"
						aria-label="help link"
					>
						<QuestionMark fontSize="small" />
					</IconButton>
				)}
				{tab === 'lookups' && (
					<Tooltip
						title={`${t('tooltip.openInNewTab')}`}
						arrow
						placement="bottom-start"
						disableInteractive
					>
						<span>
							<IconButton
								sx={environment.iconsTheme}
								className={classes.conditionBuild}
								onClick={() => onHandleOpenFullScreenTab()}
								size="small"
								aria-label="Open in new tab"
							>
								<OpenInNewIcon fontSize="small" />
							</IconButton>
						</span>
					</Tooltip>
				)}
			</GridToolbarContainer>
			{renderChart()}
		</div>
	)
}

export default DoformsDataGrid
